/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints, typography2 } from '@coursera/cds-core';

import type { ConsumerPageHeader_EnterpriseProgramFragment as EnterpriseProgramFragment } from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';
import { EnterpriseSearchBarImpl } from 'bundles/enterprise-learner-search/components/search/EnterpriseSearchBarV2';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';

import _t from 'i18n!nls/composable-page-header-enterprise';

type Props = {
  thirdPartyOrganizationSlug?: string;
  enrolledEnterprisePrograms?: Partial<EnterpriseProgramFragment>[] | null;
};

const styles = {
  searchBar: css`
    && {
      ${breakpoints.up('lg')} {
        width: 100%;
      }

      .rc-EnterpriseSearchBarV2 {
        max-width: 480px;
        min-width: 0;
        width: 100%;

        input {
          /* Needs important to override old style that's also set to important. Yuck! */
          font: ${typography2.bodySecondary.font} !important;
          letter-spacing: ${typography2.bodySecondary.letterSpacing};
        }
      }
    }
  `,
};

export function EnterpriseOrgScopedSearchBarGridItem(props: Props) {
  const { thirdPartyOrganizationSlug, enrolledEnterprisePrograms } = props;

  const enterpriseProductFeatures = useEnterpriseProductFeatures();

  if (!thirdPartyOrganizationSlug) {
    return null;
  }

  const enableSkillsInSearchAndBrowse = enterpriseProductFeatures?.enableSkillsInSearchAndBrowse;
  const shouldShowShortFormContent = enterpriseProductFeatures?.allowShortFormContentBasedOnAudience;

  const programIds: Array<string> =
    enrolledEnterprisePrograms
      ?.filter((program) => program?.naptimeThirdPartyOrganization?.slug === thirdPartyOrganizationSlug)
      ?.map((program) => program?.id ?? '') ?? [];

  const scopes = [
    {
      trackingData: { thirdPartyOrgSlug: thirdPartyOrganizationSlug },
      // TODO: update pathname to use new org scoped search page https://coursera.atlassian.net/browse/HOME-4497
      pathname: `/programs/all/${thirdPartyOrganizationSlug}`,
      placeholder: _t('Search in all programs you joined...'),
      title: _t('All Learning Programs'),
      programIds,
    },
  ];

  if (enrolledEnterprisePrograms?.length) {
    return (
      <div css={styles.searchBar}>
        <EnterpriseSearchBarImpl
          initialScopeIndex={0}
          scopes={scopes}
          enableSkillsInSearchAndBrowse={!!enableSkillsInSearchAndBrowse}
          shouldShowShortFormContent={shouldShowShortFormContent}
        />
      </div>
    );
  } else {
    return null;
  }
}

export default EnterpriseOrgScopedSearchBarGridItem;
